/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  document.addEventListener('quizKitResultsPageLoaded', (e) => {
    setTimeout(createButtonRetake, 3000);
  });

  const addLinktoBanner = () => {
    var bannerHero = document.querySelectorAll('[data-section-id="heroImage_7"] img');
    var link = document.createElement('a');
    link.setAttribute('href','/products/starter-pack');
    if (typeof(bannerHero) != 'undefined' && bannerHero != null) {
      bannerHero[0].parentNode.appendChild(link);
      link.appendChild(bannerHero[0]);
    }
  }

  const createButtonRetake = () => {
    let section = document.querySelectorAll('[data-section-id="products_1"]');
    let wrapper = document.createElement('div');
    let button = document.createElement('button');
    wrapper.setAttribute('id','wrapper-retake-custom');
    wrapper.setAttribute('style','text-align: center; margin: 50px auto 0 auto;');
    button.setAttribute('id','retake-button-custom');
    button.setAttribute('onclick', 'retakeQuiz();');
    button.setAttribute('style', 'width: auto; height: auto; min-height: auto; font-family: "Beatrice Regular"; font-size: 15px; color: rgb(234, 83, 21); font-weight: 300; border-top: none; border-right: none; border-bottom: 1px solid rgb(234, 83, 21); border-left: none; border-image: initial; background: none; line-height: 1.7rem; border-radius: 0px; letter-spacing: 0.5px;');
    button.innerHTML = 'RETAKE QUIZ';
    if (typeof(section) != 'undefined' && section != null) {
      wrapper.appendChild(button);
      section[0].after(wrapper);
      createButtonShop();
    }
  }

  const createButtonShop = () => {
    let section = document.querySelectorAll('#layout-1-results-retake-button, #retake-button-custom');
    let button = document.createElement('button');
    button.setAttribute("onclick", "window.location.href='/pages/shop-products';");
    button.setAttribute('style', 'width: auto; height: auto; min-height: auto; font-family: "Beatrice Regular"; font-size: 15px; color: rgb(234, 83, 21); font-weight: 300; border-top: none; border-right: none; border-bottom: 1px solid rgb(234, 83, 21); border-left: none; border-image: initial; background: none; line-height: 1.7rem; border-radius: 0px; letter-spacing: 0.5px; margin: 0 auto 0 20px;');
    button.innerHTML = 'KEEP SHOPPING';
    if (typeof(section) != 'undefined' && section != null) {
      for(let i = 0; i < section.length; i++) {
        section[i].after(button.cloneNode(true));
      }
    }
  }
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

const retakeQuiz = () => {
  if (localStorage.getItem('quizKitCustomerCompletions') != null) {
    localStorage.removeItem('quizKitCustomerCompletions');
  }
  if (localStorage.getItem('quizKitResultsProducts') != null) {
    localStorage.removeItem('quizKitResultsProducts');
  }
  window.location.href = '/pages/fit-quiz';
}
